import { createAllowListStore } from "./factories/create-allow-list-store.ts";

export const useMicrosoftDriveSettingsStore = createAllowListStore({
  storeId: "microsoft-drive-settings",
  integrationPath: "integrations/microsoft-365",
});
